/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FileGlobeIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'File Globe',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M20 2v10h10L20 2zM26.157 29.272c1.1 1.641 2.773 4.159 1.887 6.418a3.075 3.075 0 0 1-.463-.073c-2.484-.527-6-2.931-6-6.966a7.117 7.117 0 0 1 2.893-5.706c.118 1.433-1.078 2.155-.615 3.831.541 1.974 1.379 1.129 2.298 2.496Zm9.052-.166c-.713-.271-1.325.653-1.379-1.844a2.552 2.552 0 0 1 .738-1.771 1.361 1.361 0 0 1 .323-.154c-.084-.155-.179-.3-.274-.451-.017.009-.031.02-.048.027-.554.258-.63.334-.886 0a.7.7 0 0 1 .153-1.03 7.078 7.078 0 0 0-5.16-2.312c.9.012 1.969.677 1.423 1.74.082-.169-1.783-.571-2.037-.571-.342 0 .7-1.279.6-1.168a7.121 7.121 0 0 0-2.929.63c.484.313 1.023.2 1.569.338a1.328 1.328 0 0 1 .486.2 1.636 1.636 0 0 0-.486-.2c-.8-.093.39 2.115.344 1.821a1.02 1.02 0 0 1 2.024-.061 1.655 1.655 0 0 1-.371 1c-.624.821-.751 2.282-1.063 1.908-2.918-1.2-2.6.386-1.639 1.442 1.534 1.691.755.173 2.764 1.059 1.615.712 3.559.881 3.085 1.418-1.435 1.625-1.133 2.7-3.672 4.607.211-.006.885-.073 1.023-.1a7.206 7.206 0 0 0 5.922-6.376 1.061 1.061 0 0 1-.51-.152Z"
    />
    <path
      d="M18.591 28.643A10.062 10.062 0 0 1 30 18.673V14H19a1 1 0 0 1-1-1V2H7a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h13.135a10.015 10.015 0 0 1-1.544-5.357Z"
    />
  </svg>`;
};
